import {Component, OnInit} from '@angular/core';
import {NavigationEnd, Router, RouterLink, RouterOutlet} from '@angular/router';
import {initFlowbite} from 'flowbite';
import {AuthenticationService} from './services/authentication/authentication.service';
import {FavoritesService} from './services/favorites/favorites.service';
import {MarketingConsentModalComponent} from './components/marketing-consent-modal/marketing-consent-modal.component';
import {MarketingConsentService} from './services/marketing-consent/marketing-consent.service';
import {EnvironmentConfigService} from './core/config/environment-config.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  imports: [
    RouterOutlet,
    RouterLink,
    MarketingConsentModalComponent,

  ],
  styleUrl: './app.component.css'
})
export class AppComponent implements OnInit {
  title = 'casato';
  currentYear = new Date().getFullYear();
  readonly isProduction: boolean;

  isLoggedIn = false;
  showMarketingConsentModal = false;
  isSavingMarketingConsent = false;
  marketingConsentError = '';
  private isCheckingMarketingConsent = false;
  private checkedMarketingConsentForSession = false;
  private isMarketingConsentPreview = false;

  constructor(private authenticationService: AuthenticationService,
              private favoritesService: FavoritesService,
              private marketingConsentService: MarketingConsentService,
              private environmentConfigService: EnvironmentConfigService,
              private router: Router) {
    this.isProduction = this.environmentConfigService.isProduction;

    this.authenticationService.isLogged.subscribe(isLogged => {
      this.isLoggedIn = isLogged;
      if (isLogged) {
        this.favoritesService.getFavorites();
        this.checkMarketingConsentDecision();
      } else {
        if (this.isMarketingConsentPreview) {
          return;
        }

        this.showMarketingConsentModal = false;
        this.isSavingMarketingConsent = false;
        this.marketingConsentError = '';
        this.checkedMarketingConsentForSession = false;
      }
    });
  }

  ngOnInit(): void {
    initFlowbite();
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.closeMobileNavbar();
      }
    });
    this.showMarketingConsentPreview();
    this.authenticationService.getCurrentUser().then();
  }

  signOut() {
    this.authenticationService.signOut().then(() => {
      this.router.navigate(['/']);
    });
  }

  scrollToTop(): void {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  private closeMobileNavbar(): void {
    const mobileNavbar = document.getElementById('navbar-default');
    const mobileNavbarButton = document.querySelector('[data-collapse-toggle="navbar-default"]');

    mobileNavbar?.classList.add('hidden');
    mobileNavbarButton?.setAttribute('aria-expanded', 'false');
  }

  async saveMarketingConsentDecision(newsletter: boolean): Promise<void> {
    this.isSavingMarketingConsent = true;
    this.marketingConsentError = '';

    try {
      await this.marketingConsentService.saveDecision(newsletter);
      this.showMarketingConsentModal = false;
      this.checkedMarketingConsentForSession = true;
    } catch (error) {
      console.error('Failed to save newsletter decision', error);
      this.marketingConsentError = 'Não foi possível salvar sua resposta. Tente novamente.';
    } finally {
      this.isSavingMarketingConsent = false;
    }
  }

  private async checkMarketingConsentDecision(): Promise<void> {
    if (this.isCheckingMarketingConsent || this.checkedMarketingConsentForSession) {
      return;
    }

    this.isCheckingMarketingConsent = true;
    this.marketingConsentError = '';

    try {
      const hasRecordedDecision = await this.marketingConsentService.hasRecordedDecision();
      this.showMarketingConsentModal = !hasRecordedDecision;
      this.checkedMarketingConsentForSession = true;
    } catch (error) {
      console.error('Failed to check marketing consent decision', error);
      this.showMarketingConsentModal = false;
    } finally {
      this.isCheckingMarketingConsent = false;
    }
  }

  private showMarketingConsentPreview(): void {
    if (window.location.hostname !== 'localhost' && window.location.hostname !== '127.0.0.1') {
      return;
    }

    const searchParams = new URLSearchParams(window.location.search);
    if (searchParams.get('previewMarketingConsent') === 'true') {
      this.isMarketingConsentPreview = true;
      this.showMarketingConsentModal = true;
      this.checkedMarketingConsentForSession = true;
    }
  }
}
